import React from 'react';
import PropTypes from 'prop-types';

import InvoiceResource from "resources/Profile/InvoiceResource";

import InvoiceForm from 'components/InvoiceForm';

import Subtitle from 'ui/text/Subtitle';

import { t } from 'i18n/index';

const InvoiceDetails = ({ setStep, senderName, senderEmail, paymentIntentId, shippingAddress}) => {

  // SELL05 — when the order shipped, prefill the billing address from the
  // shipping address the buyer just typed; every field stays editable.
  const record = {
    name: senderName,
    email: senderEmail,
    ...(shippingAddress && {
      address: shippingAddress.address,
      city: shippingAddress.city,
      post_code: shippingAddress.post_code,
      country: shippingAddress.country,
    }),
  };

  return (
    <div>
      <Subtitle>{t('literal:billingDetails')}</Subtitle>
      <p>{t('profile:memberships:claimModal:invoiceFormDescription')}</p>

      <InvoiceForm
        record={ record }
        InvoiceResource={ InvoiceResource }
        paymentIntentId={ paymentIntentId }
        onDone={setStep}
      />
    </div>
  );
};

InvoiceDetails.propTypes = {
  setStep: PropTypes.func,
  senderName: PropTypes.string,
  senderEmail: PropTypes.string,
  paymentIntentId: PropTypes.string,
  shippingAddress: PropTypes.object
};

export default InvoiceDetails;